<template>
    <Layout is-crm :content-class="'content--narrow'">
        <Spinner v-if="loading" />
        <div class="global-settings">
            <div class="global-settings__top">
                <h1 v-text="'Global settings'" />
                <div class="global-settings__toolbar"></div>
            </div>
            <div class="global-settings__menu">
                <WithGlobalPermission permission="Employee.list">
                    <router-link
                        class="button button--thick button--big button--outlined button--icon"
                        :to="editorsRoute"
                    >
                        <IconUsers fill="#ff6b06" class="button__icon" />
                        Editors
                    </router-link>
                </WithGlobalPermission>
                <WithGlobalPermission permission="Invite.list">
                    <router-link
                        class="button button--thick button--big button--outlined button--icon"
                        :to="inviteRoute"
                    >
                        <IconUser fill="#ff6b06" class="button__icon" />
                        <span v-t="'crm.customers.invites.menuItem'" />
                    </router-link>
                </WithGlobalPermission>
                <WithGlobalPermission permission="Customer.create">
                    <router-link
                        class="button button--thick button--big button--outlined button--icon"
                        :to="customerCreateRoute"
                    >
                        <IconPlus fill="#ff6b06" class="button__icon" />
                        <span v-t="'crm.customers.create.trigger'" />
                    </router-link>
                </WithGlobalPermission>
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from '@speechki-frontend/shared/ui/layout/Layout';
import Spinner from '@speechki-frontend/shared/ui/Spinner';
import { IconPlus, IconUser, IconUsers } from '@speechki-frontend/shared/ui/icons';
import { WithGlobalPermission } from '@speechki-frontend/core/auth/components';
import { mapGetters } from 'vuex';

export default {
    name: 'CustomerDetailsPage',
    components: {
        Layout,
        Spinner,
        IconPlus,
        IconUser,
        IconUsers,
        WithGlobalPermission,
    },
    data() {
        return {
            loading: false,
        };
    },
    computed: {
        ...mapGetters(['isAdmin', 'isManager']),

        user() {
            const { pk: id } = this.$store.state.auth.user;
            return { id };
        },
        editorsRoute() {
            return { name: 'editors' };
        },
        inviteRoute() {
            return { name: 'customers-id-invites', params: { id: 'speechki' } };
        },
        customerCreateRoute() {
            return { name: 'customers-create' };
        },
    },
};
</script>

<style lang="scss" src="./GlobalSettings.scss"></style>
